/** Project-wide API configuration (Architecture One). */
export function getApiBaseUrl(): string {
  return import.meta.env.VITE_API_BASE_URL ?? "";
}

export function getProjectTenantId(): string {
  return (
    import.meta.env.VITE_TENANT_ID ?? import.meta.env.VITE_X_TENANTID ?? ""
  );
}

export function getProjectPhoneCode(): string {
  return import.meta.env.VITE_PHONE_CODE ?? "";
}
